import styled, { keyframes } from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #26434a;
  justify-content: center;
  align-items: center;
  display: flex; /* Added to center children */
  margin-bottom: 96px;
  margin-top: 66px;

  @media screen and (max-width: 426px) {
    margin-bottom: 67px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

const TextBox = styled.div`
  width: 100%;
  height: auto;
  background-color: #122023;
  font-size: 48px;
  font-weight: 700;
  color: #e1ff01;
  font-family: 'JetBrains Mono', monospace;
  padding-top: 20px;
  position: relative; /* Adjusted for potential marquee effect */
  overflow: hidden; /* Hide the overflow */
  padding-bottom: 20px;

  &:hover {
    background-color: #e1ff01;
    color: #122023;

    a {
      color: #122023;
    }
  }

  a {
    text-decoration: none;
    color: #e1ff01;
  }

  @media screen and (max-width: 426px) {
    font-size: 24px;
  }
`;

const marquee = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
`;

const Title = styled.div`
  text-align: left;
  white-space: nowrap;
  display: inline-block;
  animation: ${marquee} 9s linear infinite;
`;

const Byline = styled.div`
  text-align: right;
  padding-right: 2%;
`;

// Component remains the same


const ArticleCard = ({ props }) => {
  return (
    <>
      <Container>
        <TextBox>
          <a href={props.article_url}>
            <Title>{props.article_title.toUpperCase()}</Title>
          </a>
          <Byline>By {props.article_byline}</Byline>
        </TextBox>
      </Container>
    </>
  );
};

export default ArticleCard;

// THIS IS AN EXAMPLE OF AN ARTICLE WITH A REALLY LONG TITLE THIS IS AN EXAMPLE OF AN ARTICLE WITH A REALLY LONG TITLE
// Joe Bruin
